import { render, staticRenderFns } from "./ReceiptPaymentDetail.vue?vue&type=template&id=8dd46bd4&scoped=true"
import script from "./ReceiptPaymentDetail.vue?vue&type=script&lang=js"
export * from "./ReceiptPaymentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd46bd4",
  null
  
)

export default component.exports